import { Box, Typography } from "@mui/material";
import Sidebar from "../../components/sidebar/sidebar";
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";

import CreateGroup from "../../components/groupLoanComponent/createGroupLoan";
import CreatePigmy from "../../components/groupPigmyComponent/createGroupPigmy";
import GroupTable from "../../components/groupPigmyComponent/groupPigmyTable";
import ViewGroupDetails from "../../components/groupLoanComponent/viewGroupDetails";

function GroupPigmy() {
  const navigate = useNavigate();
  return (
    <>
      {" "}
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={65} />
            <Box>
              <Typography variant="h4">Group Pigmy</Typography>
            </Box>

            <Box mt={1}>
              {/* Nested Routes will be rendered here  */}
              <Routes>
                <Route path="/" element={<GroupTable />} />
                <Route path="/create-group-pigmy" element={<CreatePigmy />} />
                
                {/* <Route path="/overview/:id" element={<OverviewTabs />} /> */}
              </Routes>
            </Box>
          </Box>
        </Box>
        {/* Outlet is used for rendering nested routes if further nesting is needed */}
        <Outlet />
      </div>
    </>
  );
}

export default GroupPigmy;
